import { InjectionToken } from '@angular/core';

import { FormModalConfig } from '../services/component-modal.service';

export const COMPONENT_MODAL_DATA = new InjectionToken<FormModalConfig>('COMPONENT_MODAL_DATA');
